/* NEW: UI_REVAMP */
import dayjs from 'dayjs';
import React from 'react';
import AppliedFilterChips from '../../filter/AppliedFilterChips';
import { RECORD_FILTER_CHIP_STYLES } from '../../../styles/recordUiTokens';
import { getRecordFilterChipStyle } from '../historyStatusStyles';

const AppliedHistoryFilters = ({
	startDate,
	endDate,
	ticketStatus,
	siteFilter,
	onClearDateRange,
	onClearTicketStatus,
	onClearSite,
}) => {
	const hasDateRangeFilter = Boolean(startDate && endDate);
	const isDefaultDateRange =
		hasDateRangeFilter &&
		dayjs(startDate).isSame(dayjs(), 'day') &&
		dayjs(endDate).isSame(dayjs(), 'day');
	const hasTicketStatus = ticketStatus && ticketStatus !== 'All';
	const hasSiteFilter = siteFilter && siteFilter !== 'All';
	const ticketStatusStyle = getRecordFilterChipStyle(ticketStatus);
	const chips = [
		hasDateRangeFilter
			? {
					key: 'date-range',
					label: `${dayjs(startDate).format('YYYY-MM-DD')} - ${dayjs(endDate).format('YYYY-MM-DD')}`,
					...RECORD_FILTER_CHIP_STYLES.dateRange,
					onClear: isDefaultDateRange ? undefined : onClearDateRange,
				}
			: null,
		hasSiteFilter
			? {
					key: 'site',
					label: siteFilter,
					...RECORD_FILTER_CHIP_STYLES.site,
					onClear: onClearSite,
				}
			: null,
		hasTicketStatus
			? {
					key: 'ticket-status',
					label: ticketStatusStyle.label,
					background: ticketStatusStyle.background,
					color: ticketStatusStyle.color,
					onClear: onClearTicketStatus,
				}
			: null,
	];

	return <AppliedFilterChips chips={chips} />;
};

export default AppliedHistoryFilters;
